import { Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "./CashFlow";

export default function Legend() {
  const { t } = useTranslation();

  return (
    <>
      <Row className={"mb-10"}>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"invoicingBAC"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.invoicingBAC")}</Col>
          </Row>
        </Col>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"cashInBAC"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.cashInBAC")}</Col>
          </Row>
        </Col>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"costsBAC"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.costsBAC")}</Col>
          </Row>
        </Col>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"revenueBAC"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.revenueBAC")}</Col>
          </Row>
        </Col>
      </Row>
      <Row className={"mb-10"}>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"invoicingEAC"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.invoicingEAC")}</Col>
          </Row>
        </Col>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"cashInEAC"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.cashInEAC")}</Col>
          </Row>
        </Col>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"costsEAC"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.costsEAC")}</Col>
          </Row>
        </Col>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"revenueEAC"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.revenueEAC")}</Col>
          </Row>
        </Col>
      </Row>
      <Row className={"mb-10"}>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"invoicingActual"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.invoicingActual")}</Col>
          </Row>
        </Col>
        <Col md={12} lg={6}>
          <Row justify="center">
            <Col span={6}>
              <div className={"cashInActual"} />
            </Col>
            <Col span={14}>{t("projectsManagement.dashboard.cashFlow.cashInActual")}</Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
